<template>
    <div>
        <b-loading v-model="isGlobalLoaderActive" :is-full-page="true"></b-loading>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'


export default {
    data: () => ({
        isGlobalLoaderActive: true
    }),
    mounted () {
        if (this.userInitialized) {
            this.redirectToPage()
        }
    },
    computed: {
        ...mapGetters({
            currentUser: 'e/users/currentUser',
            userInitialized: 'e/users/userInitialized',
        }),
    },
    methods: {
        redirectToPage() {
            let route = null
            if (!this.currentUser.hasAnyRoles) {
                route = {name: 'my-application.new'}
            } else if (!this.currentUser.hasRoles) {
                route = {name: 'my-application.index'}
            } else if (this.currentUser.isAdmin || this.currentUser.isEngineer) {
                route = {name: 'applications.cpo-approving'}
            } else {
                route = {name: 'tickets.index'}
            }

            if (route) this.$router.push(route)
        }
    },
    watch: {
        userInitialized(initialized) {
            if (initialized) {
                this.redirectToPage()
            }
        }
    }
};
</script>
